import { ContactBanner } from "./ContactBanner/ContactBanner"
import { ContactUSForm } from "./ContactUSForm/ContactUSForm"
import { FooterContact } from "./FooterContact/FooterContact"

export const ContactUS = () => {
  return (
    <>
      <ContactBanner/>
      <ContactUSForm/>
      <FooterContact/>
    </>
  )
}
